// Parsed at build time from docs/changelog/, one Markdown file per item (apps/client/changelog-plugin.ts).
import notes from "virtual:changelog";
import { h } from "./dom.ts";

export const currentVersion = notes.releases[0]!.version;

let nextHeadingId = 0;

/** Release notes in a native modal, shared by the lobby and in-game HUD. */
export class Changelog {
  private readonly dialog: HTMLDialogElement;

  constructor(parent: HTMLElement) {
    const headingId = `changelog-heading-${nextHeadingId++}`;
    const closeButton = h("button", { type: "button", autofocus: "" }, ["Close"]);
    closeButton.addEventListener("click", () => this.close());

    const releases = notes.releases.map((release) => h("article", { class: "changelog-release" }, [
      h("div", { class: "changelog-meta" }, [
        h("span", { class: "changelog-version" }, [`Version ${release.version}`]),
        h("time", { datetime: release.date }, [release.date]),
      ]),
      h("h2", {}, [release.title]),
      h("p", { class: "changelog-summary" }, [release.summary]),
      ...release.sections.map((section) => h("section", { class: "changelog-section" }, [
        h("h3", {}, [section.title]),
        h("ul", {}, section.items.map((item) => h("li", {}, [item]))),
      ])),
    ]));

    this.dialog = h("dialog", {
      class: "card changelog",
      "aria-labelledby": headingId,
    }, [
      h("header", { class: "changelog-header" }, [
        h("h1", { id: headingId }, ["What’s new"]),
        closeButton,
      ]),
      h("div", { class: "changelog-content", tabindex: "0", role: "region", "aria-label": "Release notes" }, releases),
    ]);
    parent.append(this.dialog);
  }

  get isOpen(): boolean {
    return this.dialog.open;
  }

  open(): void {
    if (!this.dialog.open) this.dialog.showModal();
  }

  close(): void {
    if (this.dialog.open) this.dialog.close();
  }

  dispose(): void {
    this.close();
    this.dialog.remove();
  }
}
